import React, { createContext, ReactNode } from 'react';
import { useQuery } from '@apollo/client';
import { ICurrency } from 'interfaces/ICurrency';
import { GET_CURRENCIES } from 'graphql/currency/queries';
import AuthService from 'services/Auth';

interface CurrencyContextType {
  currencies: ICurrency[];
}

const CurrencyContext = createContext<CurrencyContextType | undefined>(
  undefined,
);

interface PropTypes {
  children: ReactNode;
}

export const CurrencyProvider: React.FC<PropTypes> = ({ children }) => {
  const isOktaLoggedIn = AuthService.isAuthenticated();

  const { data } = useQuery<{ currencies: ICurrency[] }>(GET_CURRENCIES, {
    skip: !isOktaLoggedIn,
    onCompleted: data => {
      updateGlobalCurrencies(data.currencies ?? []);
    },
    fetchPolicy: 'cache-first',
  });

  return (
    <CurrencyContext.Provider value={{ currencies: data?.currencies || [] }}>
      {children}
    </CurrencyContext.Provider>
  );
};
export let globalCurrencies: ICurrency[] = [];

export const updateGlobalCurrencies = (currencies: ICurrency[]) => {
  globalCurrencies = currencies;
};
